import React, { useState } from 'react';
import { InputNumber, InputNumberProps, Select, Space, Tag } from 'antd';
import Lang from '../../../common/model/global/Lang';
import FileUtil, { Unit } from '../../../common/util/FileUtil';
import Color from '../../../common/model/base/option/Color';

const InputSize = ({
  defaultValue,
  value,
  onChange,
  ...otherProps
}: InputNumberProps<number>) => {
  const v = value ?? defaultValue;
  const [num, setNum] = useState<number | null>(
    v ? FileUtil.bytesToNumUnitTuple(v)[0] : null // 或者选择其他适合的默认值
  );
  const [unit, setUnit] = useState<Unit>(
    v ? FileUtil.bytesToNumUnitTuple(v)[1] ?? 'GB' : 'GB'
  );

  const renderAfter = () => {
    return (
      <Select value={unit} onChange={handleChangeUnit}>
        {FileUtil.sizeUnits.map((u) => (
          <Select.Option key={u} value={u}>
            {u}
          </Select.Option>
        ))}f
      </Select>
    );
  };

  const change = (unit: Unit, num?: number) => {
    if (!num) {
      onChange?.(0);
    }
    onChange?.(num === -1 ? -1 : num! * FileUtil.unitToBytes(unit));
  };

  const handleChangeNum = (value: number | null) => {
    setNum(value);

    // 仅当 value 不是 null 时调用 change 方法
    if (value !== null) {
        change(unit, value);
    } else {
        // 这里可以处理 value 为 null 时的逻辑，例如传递 undefined
        change(unit, undefined);
    }
};


const handleChangeUnit = (u: Unit) => {
  setUnit(u);
  // 如果 num 是 null，则传递 undefined，否则传递 num
  change(u, num !== null ? num : undefined);
};

  return (
    <Space>
      <InputNumber
        value={num}
        addonAfter={renderAfter()}
        min={-1}
        precision={0}
        onChange={handleChangeNum}
        {...otherProps}
      />
      {num === -1 && (
        <Tag color={Color.PRIMARY}>{Lang.t('preference.noLimit')}</Tag>
      )}
    </Space>
  );
};

export default InputSize;
